import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToSection } from '../utils/scrollUtils';

export const useAnchorScroll = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      // Add a small delay to ensure the page is fully rendered
      setTimeout(() => {
        scrollToSection(sectionId, 80);
      }, 100);
    }
  }, [location.hash]);
}; 